import React from 'react';
import { ProductInformationCard, ProductInformationProps } from '../ProductInformation/ProductInformationCard';
import { styles } from './WhatsComing.css';
import { ShipmentStatus } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';

export type WhatsComingProps = {
  status: ShipmentStatus;
  orderNumber: string;
  lineItems: Array<ProductInformationProps>;
};

export const WhatsComing = ({ status, orderNumber, lineItems }: WhatsComingProps) => {
  const isCancelled = status === 'Cancelled';
  const heading = (() => {
    switch (status) {
      case 'Delivered':
      case 'Collected':
        return 'What you got';
      case 'Cancelled':
        return 'Cancelled and refunded items';
      default:
        return 'Whatʼs coming';
    }
  })();

  return (
    <div data-test-id="order-tracking-whats-coming">
      <div className={styles.header({ isCancelled })}>
        <h2 className={styles.heading}>{heading}</h2>
        {isCancelled ? (
          <div role="paragraph">
            Unfortunately, these items in your order have been cancelled. Please allow{' '}
            <strong>1 - 3 business days for your refund to be processed</strong> back to your payment method.
          </div>
        ) : (
          <div role="paragraph">
            Order <strong>#{orderNumber}</strong>
          </div>
        )}
      </div>
      {lineItems.map((lineItem, i) => (
        <div key={`${lineItem.product?.sku}-${i}`} className={styles.cardWrapper}>
          <ProductInformationCard {...lineItem} />
        </div>
      ))}
    </div>
  );
};
